import styled, { css } from 'styled-components'
import { rem } from 'utils/common'
import { fonts } from '../Variable'
import { merchantThemes } from '../Variable'

export const FAQPreviewList = styled.ul`
	margin: ${rem(20, 0)};
`
export const FAQPreviewListItem = styled.li`
	position: relative;
	list-style-type: none;
	color: ${({ theme }) => theme.color.grayTen};
	font-family: ${fonts.signika};
	font-size: ${rem(16)};
	padding: ${rem(11, 0, 11, 44)};

	${(p) =>
		p.theme.name === merchantThemes.woodwood &&
		css`
			font-family: ${fonts.WWBeta8Regular};
		`}

	${(p) =>
		p.theme.name === merchantThemes.hh &&
		css`
			font-family: ${fonts.dinPro};
		`}
	 
    ${(p) =>
		p.theme.name === merchantThemes.marysia &&
		css`
			font-family: ${fonts.futura};
		`}
	${(p) =>
		p.theme.name === merchantThemes['8848'] &&
		css`
			font-family: ${fonts.futura};
		`}
		${(p) =>
		p.theme.name === merchantThemes.aycane &&
		css`
			font-family: ${fonts.IBMPlex};
		`}
		${(p) =>
		p.theme.name === merchantThemes.bymalina &&
		css`
			font-family: ${fonts.Avenir};
		`}
		${(p) =>
		p.theme.name === merchantThemes.henrylloyd &&
		css`
			font-family: ${fonts.Gotham};
		`}
		${(p) =>
		p.theme.name === merchantThemes.chimi &&
		css`
			font-family: ${fonts.AmericaExpandedRegular};
		`}
		${(p) =>
		p.theme.name === merchantThemes.ogoship &&
		css`
			font-family: ${fonts.usual};
		`}
		${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-family: ${fonts.MonumentGrotesk};
		`}
		${(p) =>
		p.theme.name === merchantThemes.sns &&
		css`
			font-family: ${fonts.AktivGroteskEx};
		`}
`

export const FAQPreviewListItemTitle = styled.div`
	cursor: pointer;
	&:hover {
		color: ${({ theme }) => theme.color.blackOne};
		text-decoration: underline;
	}
	${(p) =>
		p.isOpen &&
		css`
			color: ${({ theme }) => theme.color.blackOne};
			text-decoration: underline;
		`}
`

export const FAQPreviewListItemText = styled.div`
	height: 0;
	overflow: hidden;
	padding: 0 0 0 0;
	font-weight: 200;
	transition: all 0.2s ease-in-out;
	line-height: 0;

	${(p) =>
		p.isOpen &&
		css`
			padding: ${rem(10, 10, 0, 10)};
			line-height: 1.5;
			height: auto;
		`}
`

export const FAQPreviewIcon = styled.div`
	position: absolute;
	left: 0;
	margin-top: ${rem(-7)};

	& > svg {
		height: ${rem(32)};
		width: ${rem(32)};
		fill: ${({ theme }) => theme.color.primary};
	}
`
